import React, { Component } from 'react';
import { login } from '../api';
import './style/login.css';
import {withTranslation} from "react-i18next";


class Login extends Component {
  constructor(props) {
    super(props);

    const  {data: {cgu}} = props.router.getState();

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCGUChecked = this.handleCGUChecked.bind(this);

    this.login = this.login.bind(this);
    this.state = {
      email: '',
      password: '',
      error: false,
      success: false,
      cgu: cgu,
      cgu_activated: cgu.last_version_at !== null,
      // cgu_activated: false,
      cgu_checked: false,
      cgu_required_error: false,
    }
  }

  login() {
    const {email, password, cgu_checked, cgu_activated} = this.state;
    this.setState({ error: false, success: false, cgu_required_error: false});

    if (cgu_activated && cgu_checked === false) {
      this.setState({ cgu_required_error: true });
      return;
    }

    login(email, password).then((x) => {
      if (x) {
        this.setState({ success: true });
        setTimeout(() => {
          // this.props.router.navigate('postfeed', {reload: true});
          window.location.href = this.props.router.buildPath("postfeed");
        }, 500)
      } else {
        this.setState({ error: true });
      }
    }).catch((x) => {
      this.setState({ error: true });
    })
  }

  handleInputChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleCGUChecked(e) {
    this.setState({cgu_checked: !this.state.cgu_checked})
  }

  acceptCGU(cgu) {
    const t = this.props.t;

    // En cochant cette case, je déclare avoir pris connaissance des conditions générales d’utilisation du site internet et les accepte.&nbsp;
    return <div className="loginCGU">
      <input type="checkbox" name="cgu_checked" value={this.state.cgu_checked} onChange={this.handleCGUChecked} />
      { cgu.label_fr }
      &nbsp;
      <a href="/app_config/file/cgu/fr" target="_blank" download style={{textDecoration: "underline"}}>
      Consulter les CGU
      </a>

      { this.state.cgu_required_error
        && <div className={'loginMessage loginErrorMessage'}>{t('Vous devez accepter les CGU')}</div>
      }
    </div>
  }

  render() {
    const active = (this.state.email!=="" && this.state.password!=="")? "active":"" ;
    const t = this.props.t;

    const mail = "support@reticularproject.com";

    return (
    <div className={'loginContainer'}>
      <div className={'loginSplitContainer loginLogoContainer'}>
          <div className={'loginLogo'}>
          </div>
        <div className={'loginLogo loginLogo2'} >
        </div>
      </div>
      <div className={'loginSplitContainer loginFormContainer'}>
        <div className={'loginInputGroupContainer'}>
          { this.state.success && <div className={'loginMessage loginSuccessMessage'}>{t('Connexion réussie (redirection)')}</div> }
          <div className={'loginFormTitle'}>
            {t('Connexion')}
          </div>
          { this.state.error && <div className={'loginMessage loginErrorMessage'}>{t('Échec de connexion')}</div> }
          <div className={'loginInputContainer'}>
            <label className={'loginFormLabel'}>  {t('Adresse e-mail')} </label>
            <input placeholder={'Saisissez votre adresse e-mail'} className={'loginFormInput'} type="text" name="email" value={ this.state.email }
             onChange={this.handleInputChange} />
          </div>
          <div className={'loginInputContainer'}>
            <label className={'loginFormLabel'}>  {t('Mot de passe')}</label>
            <input placeholder={'Saisissez votre mot de passe'} className={'loginFormInput'} type="password" name="password" value={ this.state.password }
             onChange={this.handleInputChange} />
          </div>
        </div>

	{ this.state.cgu_activated && this.acceptCGU(this.state.cgu, this.state.cgu_checked) }

        <button className={`loginFormButton ${active}`} onClick={this.login}>  {t('Se connecter')}</button>
        <div className={"loginBottomTextContainer"}>
          <p className={"loginBottomText"}>
            {t('Mot de passe oublié ? Veuillez contacter Reticular par mail à l\'adresse ')}<br/>
            <a href={'mailto:' + mail}>{ mail }</a>
          </p>
        </div>
      </div>

      <div>


      </div>
    </div>)
  }
}



export default withTranslation()(Login);
